/* Probably unused along with pagination-list but not safe to remove */
module.exports = Em.Component.extend({
    actions: {
        selectPage: function(pageNo) {
            this.sendAction('selectPage', pageNo)
        }
    }
})
